var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 10.9998C14.209 11.1205 14.1859 11.2401 14.1403 11.3517C14.0947 11.4634 14.0275 11.565 13.9425 11.6507L10.2758 15.3173C10.1904 15.4028 10.0889 15.4706 9.97724 15.5169C9.86557 15.5631 9.74588 15.5869 9.62501 15.5869C9.50414 15.5869 9.38445 15.5631 9.27278 15.5169C9.16111 15.4706 9.05964 15.4028 8.97417 15.3173C8.8887 15.2319 8.82091 15.1304 8.77465 15.0187C8.7284 14.9071 8.70459 14.7874 8.70459 14.6665C8.70459 14.5456 8.7284 14.4259 8.77465 14.3143C8.82091 14.2026 8.8887 14.1011 8.97417 14.0157L12.0083 10.9998L9.09334 7.97483C8.99957 7.8905 8.92422 7.78774 8.87198 7.67296C8.81974 7.55818 8.79175 7.43386 8.78975 7.30777C8.78775 7.18168 8.81179 7.05653 8.86037 6.94016C8.90894 6.82378 8.98101 6.71868 9.07206 6.63143C9.1631 6.54417 9.27118 6.47664 9.38951 6.43306C9.50785 6.38948 9.6339 6.37078 9.7598 6.37814C9.88569 6.3855 10.0087 6.41876 10.1212 6.47583C10.2336 6.5329 10.3331 6.61256 10.4133 6.70983L13.9517 10.3765C14.1133 10.5441 14.2051 10.767 14.2083 10.9998Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.8dbeb6b162fc8ca13cd587b8f797bb9b.svg";
export { ForwardRef as ReactComponent };